import {createSlice} from '@reduxjs/toolkit';
import { rowsPerPageJsonData } from '../utils/JsonData';


//here just create for goals


const initialState = {
     goalsList: [],
     goalsDetail: null, 
    goalsDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
    },
     goalsSearchFilters: {
    searchText: "",
  },
    };

const goalsSlice = createSlice({
    name: 'goalsSlice',
    initialState: initialState,
    reducers: {
        goalsListSucess: (state, action) => {
            state.goalsList = action.payload;
        },
        goalsListFailed: (state, action) => {
            state.goalsList = [];
        },
        goalsDetailSuccess: (state, action) => {
            state.goalsDetail = action.payload;
        },
        goalsDetailFailed: (state, action) => {
            state.goalsDetail = null;        
        },
        goalsDatagridOptionsSuccess: (state, action) => {
        state.goalsDatagridOptions =  {...state.goalsDatagridOptions, [action.payload.key]: action.payload.value}
        },
        goalsSearchFiltersSuccess: (state, action) => {
        state.goalsSearchFilters = {...state.goalsSearchFilters, [action.payload.key]: action.payload.value};
    },
    }
});

export const {
    goalsListSucess,
    goalsListFailed,
    goalsDetailSuccess,
    goalsDetailFailed,
    goalsDatagridOptionsSuccess,
    goalsSearchFiltersSuccess
} = goalsSlice.actions;

export default goalsSlice.reducer;
